import type { TaggedPreference } from '@elara/domain/models/schemas/shared-schemas';

/** Convert a text string into tagged preference items (one per line) */
export function textToPreferences(text: string, source: 'user' | 'elara' = 'user'): TaggedPreference[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((value) => ({ value, source }));
}

/** Convert tagged preference items back to a display string */
export function preferencesToText(prefs: TaggedPreference[] | undefined): string {
  if (!prefs?.length) return '';
  return prefs.map((p) => p.value).join('\n');
}

// The card options are shared with the admin console, which depends on `domain` only.
export { isListedTravelCreditCard, TRAVEL_CREDIT_CARD_OPTIONS } from '@elara/domain/models/profile-preferences';
